import type { ReactNode } from "react";
import { cn } from "../../lib/cn.js";

export type BadgeTone = "urgent" | "warn" | "info" | "up" | "neutral";

/** Bordered, never filled: the row tint already carries urgency. */
const TONE: Record<BadgeTone, string> = {
  urgent: "border-danger text-danger",
  warn: "border-warning text-warning",
  info: "border-border text-text-muted",
  up: "border-up text-up",
  neutral: "border-border text-text-muted",
};

export function Badge({ tone = "neutral", children }: { tone?: BadgeTone; children: ReactNode }) {
  return (
    <span
      className={cn("inline-block border px-1.5 py-0.5 text-label font-data uppercase", TONE[tone])}
    >
      {children}
    </span>
  );
}
